import EquipmentSearchFilter from '../equipment-search-filter'
import enhancedTextFilterContainer from '../equipment-search-filter/equipmentSearchFilterContainer'

export default enhancedTextFilterContainer(EquipmentSearchFilter)
